const sendToBackend = async (data) => {
  const apiBase = process.env.REACT_APP_API_URL;

  try {
    const response = await fetch(`${apiBase}/api/send-data`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    return await response.json();
  } catch (error) {
    console.error("Error contacting backend:", error);
    return { success: false };
  }
};

export default sendToBackend;
